// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"75cd724c","671":"75cd724c"}[chunkId] + ".chunk.css";
};